import InputItem from './InputItem';
import { useRef, useEffect, useState } from 'react';
import { InputDataItem } from '@/types';

interface InputContainerProps {
    inputData: InputDataItem[];
    onChange: (id: string, newValue: any) => void;
    handleToggle: (id: string) => void;
    onRemove: (id: string) => void;
    onChangeLabel: (id: string, name: any, newValue: any) => void; 
    className: string;
    inputConfigMap: any; // Add this line
}

const InputContainer: React.FC<InputContainerProps> = ({ inputData, onChange, onRemove, inputConfigMap, onChangeLabel, className, handleToggle }) => {
    const inputRefs = useRef<HTMLInputElement[]>([]);

    useEffect(() => {
        if (inputData.length > 0) {
            const lastInputRef = inputRefs.current[inputData.length - 1];
            if (lastInputRef) {
                lastInputRef.focus();
            }
        }
    }, [inputData]);
    return (
        <div className='card w-full px-4 py-2 rounded-lg'>
            <div className={`overflow-y-auto no-scrollbar bg-gradient-to-tr ${className || 'max-h-full' }`} >
                {inputData.slice().reverse().map((item, index) => {
                    
                    return (
                    <InputItem
                        key={item.id}
                        item={item}
                        onChange={onChange}
                        onRemove={onRemove}
                        // inputRef={(el) => (inputRefs.current[index] = el!)}
                        inputConfigMap={inputConfigMap}
                        onChangeLabel={onChangeLabel}
                        handleToggle={handleToggle}
                    />
                )})}
            </div>
        </div>
    );
};

export default InputContainer;
